import { PhoneNumberDto } from '@act/shared/data-transfer-objects';
import {
  formatPhoneNumber,
  getPhoneNumberDisplayName,
} from '@act/shared/utilities';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import { CenterVerticalAlign } from './common-layout';

interface PhoneNumberEntryProps {
  phoneNumber: PhoneNumberDto;
}

const PhoneNumberEntry = ({ phoneNumber }: PhoneNumberEntryProps) => {
  const labelComponent = (
    <CenterVerticalAlign>
      {getPhoneNumberDisplayName(phoneNumber)}
      {phoneNumber.primary && (
        <BeenhereIcon
          fontSize="small"
          color="primary"
          sx={{ marginLeft: '4px' }}
        />
      )}
    </CenterVerticalAlign>
  );
  return (
    <LabeledDatum
      label={labelComponent}
      datum={formatPhoneNumber(phoneNumber.number)}
    />
  );
};

export default PhoneNumberEntry;
